import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { isEqual } from 'lodash';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { shallowEqual, useSelector } from "react-redux";
import { tasksList } from "src/containers/schedule-task-container/ScheduleTaskPropTypes";
import { scheduleSubTaskReorderAPI } from "src/api/ScheduleTaskApi";

const HierarchyModal = ({ handleSearch,show, onHide }) => {
  const {
    search: { data = [] } = {},
    hierarchy = [],
  } = useSelector((state) => state.ScheduleTaskReducer, shallowEqual);
  const [items, setItems] = useState(data);//tasksList
  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(items);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    setItems(reordered);
  };

  const handleSave = async () => {
    try {
      const reorderedPayload = items.map((item, index) => ({
        subTaskId: item._id,
        parentSubTaskId: index > 0 ? items[index - 1]._id : null,
      }));
      await scheduleSubTaskReorderAPI({ data: reorderedPayload });
      onHide();
      handleSearch();
    } catch (err) {
      console.error("Failed to save order:", err);
    }
  };
  // useEffect(() => {
  //   if (show) {
  //     const mapped = (hierarchy || []).map(h => {
  //       return (data || []).find(d => d._id?.toString() === h.subTaskId?.toString());
  //     }).filter(Boolean); // Remove undefined if no match
  //     const seen = new Set();
  //     const filtered = mapped.filter(item => {
  //       const id = item._id?.toString();
  //       const isUnique = !seen.has(id) && item.initiationType === "Dependency";
  //       if (isUnique) seen.add(id);
  //       return isUnique;
  //     });
  //     setItems(filtered);
  //   }
  // }, [show]);
useEffect(() => {
  if (show) {
    const seen = new Set();
    const filtered = (data || []).filter((item) => {
      const id = item._id?.toString();
      const isDependency = item.initiationType === "Dependency";
      const isInHierarchy =
        !hierarchy?.length || 
        hierarchy.some(h => h.subTaskId?.toString() === id);
      const isUnique = !seen.has(id) && isDependency;// && isInHierarchy;
      if (isUnique) seen.add(id);
      return isUnique;
    });
    setItems(filtered);
  }
}, [show]);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <div>
          <h5 className="mb-1 font-24">Reorder Tasks & Set Hierarchy</h5>
          <small className="text-muted">
            Drag to reorder. Tasks above become parents of tasks below.
          </small>
        </div>
      </Modal.Header>

      <Modal.Body>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="hierarchyTasks">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {items.map((task, index) => (
                  <Draggable
                    key={task.subTaskName + index}
                    draggableId={task.subTaskName + index}
                    index={index}
                    onc
                  >
                    {(provided) => (
                      <div
                        className="border rounded p-3 mb-3 bg-white shadow-sm"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                      >
                        <div className="d-flex justify-content-between align-items-start w-100">
                          <div className="d-grid flex-column flex-md-row w-100" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gap: '7px 40px' }}>
                            <div className='font-14 d-flex gap-2'><strong>Task:</strong> {task.taskId.taskName}</div>
                            <div className='font-14 d-flex gap-2'><strong>Subtask:</strong> {task.subTaskName}</div>
                            <div className='font-14 d-flex gap-2'><strong>Assigned To:</strong> {task.assignTo} ({task?.users?.map((user) => user.firstName).join(', ')})</div>
                            <div className='font-14 d-flex gap-2'><strong>Duration:</strong> {task.duration || 'N/A'}</div>


                            <div className='font-14 d-flex gap-2'><strong>Recurring:</strong>{task.selectedDays?.join(', ')} </div>
                            <div className='font-14 d-flex gap-2'><strong>Dependency:</strong> {index > 0 ? items[index - 1].subTaskName : 'Root Task'}</div>
                          </div>


                          <div
                            className="cursor-grab"
                            {...provided.dragHandleProps}
                            style={{
                              cursor: "grab",
                              padding: "4px 8px",
                              background: "#f1f1f1",
                              borderRadius: "5px",
                              marginLeft:'10px',
                            }}
                          >
                            &#x2630;
                          </div>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={handleSave}>
          Save Order
        </Button>
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HierarchyModal;
